// extracted by mini-css-extract-plugin
export default {"logItem":"ActivityItem_logItem__qLXkg","local":"ActivityItem_local__OK6E9","fullHeight":"ActivityItem_fullHeight__lKyK1"};